<template>
    <div>
        <div class="marginCenter">
            <div class="marginBom30 marginTop30 navTitle flex-yCenter flex-sb"></div>
            <div class="middle">
                <div class="marginBom24 flex-xCenter">
                    <el-button class="primaryBtn" type="primary" @click="myDownLoadFile(form.applyBasic.applyAtt)"
                        >下载已填写的进修申请表</el-button
                    >
                </div>
                <div class="marginBom24 flex-xCenter">
                    <FileUpload
                        ref="upload"
                        :isShowTip="false"
                        class="avatar-uploader pr"
                        @on-success="uploadSuccess"
                        id="1"
                        multiple
                        :before-upload="beforeAvatarUpload"
                        :on-success="uploadSuccess"
                        :fileType="['pdf']"
                    >
                        <template #content>
                            <el-button class="primaryBtn" type="primary">上传单位盖章的进修申请表</el-button>
                        </template>
                    </FileUpload>
                </div>
                <div class="marginBom30 flex-xCenter">
                    <el-button type="text" class="fsize22" v-if="uploadObj.url" @click="previewFile(uploadObj.url)"
                        >查看</el-button
                    >
                </div>
                <div class="fcolor_red fsize22 marginBom24">
                    请提交申请后1-3天内上传已盖章的申请表，才表示完成申请步骤。如未在23日前上传影响申请表审批进度，后果自负。
                </div>
                <div class="remark fsize16">
                    <div>说明：</div>
                    <div>
                        1、请点击“下载已填写的进修申请表”按钮，打印并经选送单位盖章后，扫描成pdf格式电子文档，上传系统后，再点击“提交审批”，完成最终申请；
                    </div>
                    <div>
                        2、本页可以关闭，不影响您所填写申请表资料，待您完成进修申请表扫描后，可从“我的申请”列表页对应的进修申请表一列，点击“上传”功能进入本页上传；
                    </div>
                    <div>3、进修申请表内容不可修改</div>
                </div>
            </div>
            <div class="flex-xCenter">
                <el-button type="primary" class="blueBtn1 fsize22 btn300" @click="submit">提交审批</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import { getToken } from '@/utils/auth';
import { downloadIamge, downLoadFile } from '@/utils/myUtil';
import { trainApplyUploadSealed, trainApplyDetailAdmin } from '@/utils/api';
export default {
    data() {
        return {
            form: {
                applyBasic: {}
            },
            fileList: [],
            applyDeptList: [
                {
                    deptName: '病理科',
                    sdate: '2022-11-05',
                    edate: '2022-11-05',
                    teacherName: '王唰咯'
                }
            ],
            headers: {
                Authorization: 'Bearer ' + getToken()
            },
            uploadObj: {}
        };
    },
    created() {
        console.log(this);
        trainApplyDetailAdmin(this.$parent.applyId).then((res) => {
            if (res.code == 200) {
                this.form = res.data;
            }
        });
    },
    methods: {
        // 文件上传前
        beforeAvatarUpload(file) {
            console.log(file);
            let typeList = [
                'image/jpeg',
                'image/png',
                'image/jpg',
                'application/pdf',
                'wps',
                'doc',
                'docx',
                'xls',
                'xlsx'
            ];
            const isJPG = typeList.includes(file.type);
            const isLt2M = file.size / 1024 / 1024 < 5;

            if (!isJPG) {
                this.$message.error('请上传正确的文件格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传文件大小不能超过 5MB!');
            }
            return isJPG && isLt2M;
        },
        // 上传文件成功时
        uploadSuccess(res, file, list) {
            this.$set(this.uploadObj, 'url', res.url);
            console.log(res, file, list);
        },
        previewFile(src) {
            window.open(src);
        },
        myDownLoadFile(src) {
            downLoadFile(src);
        },
        submit(e) {
            trainApplyUploadSealed(this.form.applyId, {
                sealedApplyAtt: this.uploadObj.url
            }).then((res) => {
                if (res.code == 200) {
                    (this.$parent.active = 6), (this.$parent.progress = 4);
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.backIndex:hover {
    cursor: pointer;
}
.formTitle {
    margin: 50px 0px 30px 240px;
}
.step {
    margin-bottom: 76px;
}
::v-deep .el-textarea__inner {
    height: 95px;
    font-size: 18px;
}
::v-deep .middle {
    margin-bottom: 50px;
    .el-button--text {
        color: #2d53c8;
        &:hover {
            opacity: 0.9;
        }
    }
    .el-button--primary {
        width: 300px;
        height: 60px;
        color: #2d53c8;
        font-size: 22px;
        background: #ffffff;
        border-radius: 5px;
        border: 2px solid #2d53c8;
    }
}
</style>
